let broadcastChannel: BroadcastChannel;

export function getBroadcastChannel() {
  if (!broadcastChannel) {
    broadcastChannel = new BroadcastChannel("videoscribe");
  }
  return broadcastChannel;
}

export const LOGOUT_ALL_ACTION = "LOGOUT_ALL_ACTION";
